export const pricingLink = `${CONFIG.djangoBaseUrl}/pricing`;

export const contactLink = 'https://goshippo.com/contact';

export const contactSalesLink = `${CONFIG.djangoBaseUrl}/contact/sales`;

export const billingFAQ = 'https://support.goshippo.com/hc/articles/360024703991';

export const HELP_CUSTOMS_MEXICO =
  'https://support.goshippo.com/hc/en-us/articles/31695322817179-New-Customs-Rules-for-Shipments-to-Mexico';

// React links
export const adjustPlanLink = '/settings/account/plan/adjust';

export const getHelpLink = 'https://shippo.com/get-help';

export const shippoTermsLink = 'https://goshippo.com/terms';
export const shippoPrivacyLink = 'https://goshippo.com/privacy';
export const googlePrivacyLink = 'https://policies.google.com/privacy';
export const googleTermsLink = 'https://policies.google.com/terms';

export const csvSampleFileV3 = `${CONFIG.staticUrl}/files/shippo_sample_csv_v3.csv`;

export const csvImportHelpCenterLink = 'https://support.goshippo.com/hc/en-us/articles/203948179';
